var E = /* @__PURE__ */ ((r) => (r.LEFT = "left", r.RIGHT = "right", r.CENTER = "horizontal-center", r.FILL = "fill", r))(E || {}), v = /* @__PURE__ */ ((r) => (r.TOP = "top", r.CENTER = "vertical-center", r.BOTTOM = "bottom", r))(v || {});
export {
  E as RocheUITwoColumnLayoutHorizontalAlignment,
  v as RocheUITwoColumnLayoutVerticalAlignment
};
